import React from "react";
import WhoScript from "./scripts/WhoScript";
import Features from "./features/Features";
import Brickwall from "./banners/Brickwall";

const Who = () => {
  return (
    <section
      id="who"
      className="w-full h-auto px-16 xl:px-12 lg:px-5 pt-32  pb-10"
    >
      <div className="flex w-[100%]">
        <div className="flex w-[70%] 2xl:w-[100%] lg:w-[120%] md:pt-36 pb-5 z-40">
          <WhoScript />
        </div>
        <div className="xl:pt-56 lg:pt-96 md:top-36 md:absolute">
          <Brickwall />
        </div>
      </div>
      <div className="flex w-[100%] h-auto px-10 pt-4 pb-10 border-8 shadow-lg shadow-slate-400 border-slate-950 rounded-2xl ">
        <Features
          type="album"
          title="Photos from past shows"
          des="Bring all laughs into the frames"
        />
      </div>
    </section>
  );
};

export default Who;
